export default __webpack_public_path__ + "static/service_01-ee0b3d17e6668e565faacc08cbc06255.jpg";